import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import data from "@/.sourceflow/jobs.json";

export const useJobs = ({ limit = 10 } = {}) => {
  const collection = useSourceFlowCollection(data.jobs);

  if (limit) {
    return collection.slice(0, limit);
  }

  return collection;
};

export default useJobs;
